const RECENT_BOOKINGS_KEY = 'booking.recent';
const MAX_RECENT_BOOKINGS = 10;

function safeParse(json) {
  try {
    return JSON.parse(json);
  } catch (err) {
    return [];
  }
}

export function getRecentBookings() {
  const raw = localStorage.getItem(RECENT_BOOKINGS_KEY);
  if (!raw) return [];
  const parsed = safeParse(raw);
  return Array.isArray(parsed) ? parsed : [];
}

export function addRecentBooking(booking) {
  if (!booking) return;

  const current = getRecentBookings();
  const next = [booking, ...current]
    .filter((entry) => entry && entry.panditId)
    .slice(0, MAX_RECENT_BOOKINGS);

  localStorage.setItem(RECENT_BOOKINGS_KEY, JSON.stringify(next));
}

export function getFrequentPanditSuggestion(serviceTitle) {
  const bookings = getRecentBookings();
  if (!bookings.length) return null;

  const matchingService = bookings.find((entry) => entry.serviceTitle === serviceTitle && entry.panditId);
  if (matchingService) return matchingService;

  return bookings.find((entry) => entry.panditId) || null;
}
